'use strict';

import DataLayer from "./datalayer";

let Labels = {
    initialized: false,
    worldMap: "World Map",
    allCountries: "Go To Country List",
    pageListTitle: "Clariant Locations",
    pageListSubtitle: "List of countries",
    pageListIntro: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin non pellentesque mi. Ut a ipsum hendrerit, imperdiet massa sit amet, eleifend erat. Suspendisse a orci urna. Donec ac magna cursus, laoreet eros placerat, interdum sem. Curabitur commodo mauris ac pretium fringilla. Vivamus hendrerit tincidunt ex in posuere. Nunc eleifend tortor a ligula imperdiet, finibus tincidunt tortor vulputate. Integer placerat velit et lacus ornare, at tristique ligula commodo. Phasellus dui mauris, fringilla vitae lacus in, malesuada cursus eros.",
    countryNotFound: "The country you requested could not be found. If you got to this page by clicking on a bookmark, please make sure it contains a correct country name.",
    countryMap: "Country Map",
    additionalInfo: "Additional Information",
    documents: "Documents",
    otherCountries: "Other Countries",
    viewOnMap: "View on Map",
    close: "Close",
    mapSearchPlaceholder: "Search for a location name",
    allClariantLocations: "All Clariant Locations",
    downloads: "Available Documents",
    getInContact: "Get in contact",
    "Ack1": "I allow Clariant to store and process my information for the purpose given in this contact form",
    "Ack2": "I authorize Clariant to store my contact details and/or to contact me for marketing purposes",
    get (name) {
        if (this.initialized === false) this.init();
        if (this.hasOwnProperty(name)) return this[name];
        else return name;
    },
    async init() {
        let labelEls = document.querySelectorAll(".cla-locations-params > .labels > input[type='hidden']");
        if (labelEls && labelEls.length > 0) {
            for (let i = 0; i < labelEls.length; i++) {
                const el = labelEls[i];
                this[el.name] = el.value;
            };
        }
        const res = await DataLayer.getLabels();
        if (!res.data) reject({message: "Invalid response received from server when loading labels."});
        for (const key in res.data) {
            if (res.data.hasOwnProperty(key)) {
                self[key] = res.data[key];
            }
        }
        this.initialized = true;
    }
};

export default Labels;